<div class="card">
    <app-novo-pedido-outros-servicos [legend]="'Itens'" [codLoja]="codLoja" [codCliente]="codCliente" [filtrarSomenteNaoLentes]="false" [servicosAdicionados]="servicosAdicionados"></app-novo-pedido-outros-servicos>
</div>